<template>
  <span class="tab_not">
    <span class="ctitle">
      Configurar
      <strong>e-mails</strong> para receber notificações:
    </span>
    <div class="box_lista_email">
      <v-layout row wrap>
        <v-flex xs6>
          <div
            class="total"
            v-if="notificacoes.objetos && notificacoes.objetos.length > 0 && (notificacoes.objetos.length != 1 || fakeDelete.length != 1)"
          >Total: {{notificacoes.objetos ? notificacoes.objetos.length : ''}}</div>
        </v-flex>
        <v-flex xs6>
          <v-layout row justify-end>
            <v-slide-x-reverse-transition>
              <v-tooltip
                v-if="fakeDelete.length > 0"
                left
                style="margin-top: 5.5px; display: block;"
              >
                <v-btn slot="activator" icon class="my-0" @click.native="activeItem()">
                  <v-icon>refresh</v-icon>
                </v-btn>
                <span>Desfazer deleção</span>
              </v-tooltip>
            </v-slide-x-reverse-transition>
            <v-tooltip bottom>
              <v-btn
                slot="activator"
                color="green darken-2"
                icon
                flat
                text-color="white"
                dark
                @click.native="acao.create = true;"
              >
                <v-icon class="material-icons" dark color="green">add</v-icon>
              </v-btn>
              <span>Cadastrar novo E-mail</span>
            </v-tooltip>
          </v-layout>
        </v-flex>
      </v-layout>
      <article class="list">
        <div
          class="title"
          v-if="notificacoes.objetos && notificacoes.objetos.length > 0 && (notificacoes.objetos.length != 1 || fakeDelete.length != 1)"
        >
          <v-layout align-center justify-center row fill-height style="margin-top: -11px;">
            <v-flex xs1>
              <div class="icon_email"></div>
            </v-flex>
            <v-flex xs6>
              <div class="list_title email">E-mail:</div>
            </v-flex>
            <v-flex xs4>
              <div class="acoes">
                <v-layout row justify-center>
                  <div class="list_title acoes">Ações:</div>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </div>
        <template
          v-if="notificacoes.objetos && notificacoes.objetos.length > 0 && (notificacoes.objetos.length != 1 || fakeDelete.length != 1)"
        >
          <ul>
            <li v-for="notif in notificacoes.objetos" :key="notif.email" v-if="!notif.delete">
              <v-layout align-center justify-center row fill-height>
                <v-flex xs1>
                  <div class="icon_email"></div>
                </v-flex>
                <v-flex xs6>
                  <div class="email">{{notif.email}}</div>
                </v-flex>
                <v-flex xs4>
                  <div class="acoes">
                    <v-layout row justify-end>
                      <v-tooltip bottom>
                        <v-btn
                          slot="activator"
                          color="warning darken-2"
                          icon
                          flat
                          text-color="white"
                          dark
                          @click.native="acao.edit = true, editItem = notif"
                        >
                          <v-icon class="material-icons" dark color="warning">edit</v-icon>
                        </v-btn>
                        <span>Editar Notificações</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <v-btn
                          slot="activator"
                          color="red darken-2"
                          icon
                          flat
                          text-color="white"
                          dark
                          @click.native="notif['delete'] = true, fakeDelete.push(notif)"
                        >
                          <v-icon class="material-icons" dark color="red">delete_forever</v-icon>
                        </v-btn>
                        <span>Deletar E-mail</span>
                      </v-tooltip>
                    </v-layout>
                  </div>
                </v-flex>
              </v-layout>
            </li>
          </ul>
        </template>
        <v-layout style="margin-top: 10%;" row justify-center v-else>
          <span class="msg_vazi">
            Nenhum E-mail está sendo notificado,
            <span
              class="link"
              @click="acao.create = true;"
            >cadastre agora !</span>
          </span>
        </v-layout>
      </article>
    </div>

    <ModalAddEdit :notificacoes="this.notificacoes" :editItem="this.editItem" :acao="this.acao"></ModalAddEdit>
  </span>
</template>
<script>
import ModalAddEdit from "@/components/conta/empresa/formEmpresa/tabNotificacoes/modalAddEdit/ModalAddEdit.vue";
export default {
  props: ["notificacoes"],
  components: { ModalAddEdit: ModalAddEdit },
  data: () => ({
    acao: {
      edit: false,
      create: false
    },
    editItem: {},
    fakeDelete: []
  }),
  watch: {},
  methods: {
    activeItem() {
      let lastPos = this.fakeDelete.length - 1;
      if (this.fakeDelete[lastPos].hasOwnProperty("delete")) {
        this.fakeDelete[lastPos].delete = false;
        this.fakeDelete.splice(lastPos, 1);
      }
    }
  }
};
</script>
<style scoped>
.total {
  margin: 10px;
  color: gray;
  font-size: 12px;
  font-weight: 700;
}
.list ul {
  list-style: none;
  margin-left: 13px;
  height: 175px;
  overflow-y: scroll;
  margin-right: 4px;
}
.list li {
  padding: 4px;
}
.list li .email {
  font-size: 0.9em;
  color: #4d627b;
  opacity: 0.75;
  text-overflow: ellipsis !important;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
}
.tab_not .ctitle {
  font-size: 1.1em;
  color: grey;
  padding: 0px 8px;
}
.box_lista_email {
  background-color: white;
}
.list_title {
  font-size: 14px;
  color: black;
  font-weight: 500;
}
.link {
  cursor: pointer;
  text-decoration: underline;
  color: teal;
}
.box_lista_email {
  min-height: 230px;
}
</style>


// WEBPACK FOOTER //
// src/components/conta/empresa/formEmpresa/tabNotificacoes/TabNotificacoes.vue